//NOTE: this is a style file where css is written in JS object from.
//It is used with React-select lib components. It does not yet have
//styles for multi-select. Check React-select lib doc for how to
//style multi-select, and or other custom styles.

export const DefaultSelectJSS = {
	control: (baseStyles, state) => ({
		backgroundColor: 'white',
		outline: state.isFocused ? '1px solid #00C8E4' : 'none',
		borderRadius: '3px',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between'
	}),
	dropdownIndicator: () => ({
		margin: '8px',
		width: '16px',
		height: '16px',
		color: '#7A8792',
		display: 'flex',
		alignItems: 'center'
	}),
	menuList: baseStyles => ({
		...baseStyles,
		margin: '4px',
		paddingTop: '0',
		'::-webkit-scrollbar': {
			width: '4px'
		},
		'::-webkit-scrollbar-track': {
			background: '#ebecef'
		},

		'::-webkit-scrollbar-thumb': {
			background: '#b1b5be',
			borderRadius: '4px'
		}
	}),
	groupHeading: baseStyles => ({
		...baseStyles,
		color: '#2c2c2c',
		padding: '6px 0',
		textTransform: 'none',
		fontSize: '14px'
	}),
	group: baseStyles => ({
		...baseStyles,
		padding: '0',
		margin: '0 3px',
		borderTop: '1px solid silver',
		':first-of-type': {
			borderTop: 'none'
		}
	}),
	option: (styles, { isFocused }) => ({
		...styles,
		color: isFocused ? 'white' : '#626262',
		backgroundColor: isFocused ? '#00C8E4' : 'white',
		':active': {
			...styles[':active'],
			backgroundColor: '#00C8E4'
		}
	})
}
